import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SCRAPING_REVIEW_COMMENTS_QUERY } from '../graphql/queries'
import { FETCH_SCRAPING_REVIEW_COMMENTS } from '../redux/action-types'

const useScrapingReviewCommentsQuery = menuCurationTaskId => {
  const dispatch = useDispatch()

  const { isLoading, error, data } = useSelector(
    store => store.menuCurationTasks.menuCurationTask.scrapingReviewComments,
  )

  const refetch = useCallback(
    () =>
      apolloService.query({
        query: SCRAPING_REVIEW_COMMENTS_QUERY,
        variables: {
          id: menuCurationTaskId,
        },
        dispatch,
        action: FETCH_SCRAPING_REVIEW_COMMENTS,
      }),
    [dispatch, menuCurationTaskId],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data }
}

export default useScrapingReviewCommentsQuery
